import gql from 'graphql-tag';
import { CONFIG_OFFER_FRAGMENT, OFFERS_FRAGMENT } from './fragment';

export const OFFERS = gql`
  query Offers($isPackage: Boolean) {
    offers(isPackage: $isPackage) {
      ...OffersInfo
    }
  }
  ${OFFERS_FRAGMENT}
`;

export const DISPLAY_OFFER = gql`
  query DisplayOffer {
    displayOffer {
      ...ConfigOfferInfo
    }
  }
  ${CONFIG_OFFER_FRAGMENT}
`;
